<template>
    <div class="w-full">
        <onboarding-header :current-step="3" :total-steps="3">
            <template v-slot:header>
                Invite your team mates
            </template>
            <template v-slot:description>
                Give them access to this project and specify their access privilidges. You're the owner!
            </template>
        </onboarding-header>

        <form @submit.prevent="!isSubmitting ? sendInvites() : null" class="mt-8 max-w-screen-xs">

            <div class="flex flex-col items-start space-y-5">
                <div v-for="(email, index) in emails" :key="index" class="w-full">
                    <base-input v-model.trim="emails[index]" :id="`invite-${index}`" :value="email" type="email" placeholder="Enter their work email..." /> 
                </div>

                <button type="button" @click="addNewInvite" class="focus:outline-none focus:shadow-outline text-secondary dark:text-secondary-300 underline rounded-md" ref="inviteButton">+ Invite another user</button>
            </div>

            <base-button bgColor="bg-success dark:bg-green-600" borderColor="border-success dark:border-green-500" hoverBg="hover:bg-green-400 dark-hover:bg-green-500" hoverBorder="hover:border-success-400" class="mt-10 mb-4" icon="tick" iconPosition="left"   type="submit">Send Invitations & Finish Set Up</base-button>

            <router-link :to="{ name: 'Project' }" tag="a" class="text-gray-500 underline focus:outline-none focus:shadow-outline">or finish set up without sending invites</router-link>
        </form>
    </div>
</template>

<script>
import OnboardingHeader from "../OnboardingHeader";
import { authenticationState, loading, error } from '@/mixins';
import { createInvite } from "@/graphql/mutations";
export default {
  name: "InviteTeam",
  metaInfo: {
      title: 'Invite Your Team',
  },
  components: {
    OnboardingHeader
  },
  mixins: [ authenticationState, loading, error ],
  data () {
      return {
          isSubmitting: false,
          emails: [
              ''
          ]
      }
  },
  computed: {
    invites () {
          return this.emails.filter(email => email.length).map(email => { return { email } });
    },
  },
  methods: {
      async sendInvites() {
          this.isSubmitting = true;

          try {

            const changesMade = this.invites.length;
            
            if (changesMade) {
                this.$root.$emit('loading', true);
                await this.$apollo.mutate({
                    mutation: createInvite,
                    variables: {
                        input: {
                            invites: this.invites,
                            projectId: this.authenticationState.selectedProject,
                            sendEmail: true
                        }
                    },
                });
            }
            
            this.$router.push({ name: 'Project'})
          } catch (error) {
            this.handleError(error);
          }

          this.$root.$emit('loading', false);
          
          this.isSubmitting = false;
      },
      addNewInvite () {
          this.$refs['inviteButton'].blur();
          this.emails.push('');
      }
  }
};
</script>
